export default {
  title: "Administrer Låter",
  fab: {
    new: "Ny"
  },
  list: {
    empty: "Fant ingen låter 😞"
  },
  trackstrip: {
    locale: {
      isPublished: "Ja",
      notPublished: "Nei"
    }
  }
}



// WEBPACK FOOTER //
// ./src/locales/no/page/artist/management/tracks.js